<template>
  <div id="app">
    <div class="app-wrap">
      <router-view/>
    </div>
  </div>
</template>
<script>
        
export default {
  provide() {
    return {};
  },
  computed: {},
  watch: {},
  created() {

  },
  methods:{

  }
};
</script>
<style lang="scss">
@media (max-width: 768px) {
    #app{
        background: #FFF;
        .app-wrap{
            background: #FFF;
        }
    }
    html{
        font-size:13.3vw !important;
    }
}
@media screen and (min-width: 768px) and (max-width: 992px) {
    #app{
        background: #FFF;
        .app-wrap{
            background: #FFF;
        }
    }
    html{
        font-size:10vw !important;
    }
}
@media screen and (min-width: 993px) and (max-width: 1366px) {
    #app{
        background: #FFF;
        .app-wrap{
            background: #FFF;
        }
    }
    html{
        font-size:6.5vw !important;
    }
}
</style>
